import { axiosInstance } from '.'
import {
  RESET_PASSWORD,
  USER_SIGN_IN_V1,
  USER_LOGOUT_V1,
  SEND_VERIFICATION_LINK_V1,
  ADMIN_CHANGE_PASSWORD_V1,
} from './endpoints'
import { User, Verification } from '../lib/types'

export const userServices = {
  resetPassword: async (resetPasswordData: object, headers: { [key: string]: string }) => {
    try {
      return await axiosInstance.post(RESET_PASSWORD, resetPasswordData, {
        headers: headers,
      })
    } catch (error: any) {
      return error.response
    }
  },

  // v1
  userLogin: async (loginData: User, headers: { [key: string]: string }) => {
    try {
      return await axiosInstance.post(
        USER_SIGN_IN_V1,
        {
          ...loginData,
        },
        {
          headers: headers,
        },
      )
    } catch (error: any) {
      return error.response
    }
  },
  sendVerificationLink: async (email: string, type: Verification) => {
    try {
      return await axiosInstance.post(SEND_VERIFICATION_LINK_V1, {
        email,
        type,
      })
    } catch (error: any) {
      return error.response
    }
  },
  userLogout: async (headers: { [key: string]: string }) => {
    try {
      return await axiosInstance.post(USER_LOGOUT_V1, {}, { headers: headers })
    } catch (error: any) {
      return error.response
    }
  },

  changeAdminPassword: async (body: { currentPassword: string; newPassword: string }) => {
    try {
      return await axiosInstance.post(ADMIN_CHANGE_PASSWORD_V1, body)
    } catch (error: any) {
      return error.response
    }
  },
}
